import {createStore, applyMiddleware, combineReducers, compose} from 'redux'
import reduxThunk from 'redux-thunk'
import { routerReducer, routerMiddleware } from 'react-router-redux'
import { browserHistory } from 'react-router'
import {calculateResponsiveState, responsiveStateReducer, responsiveStoreEnhancer} from 'redux-responsive-pistol-pete'
import {refreshTokenTimer, stopTokenRefresh} from './components/timeout'
import ReactGA from 'react-ga'

const composeEnhancers = compose;

const initial_state = {
    latest_payslip: { ready: false, treat_as_error: false, show_spinner: false },
    selected_payslip: { ready: false, treat_as_error: false, show_spinner: false },
    current_user: { ready: false, treat_as_error: false, show_spinner: false },
    all_payslips: { ready: false, treat_as_error: false, show_spinner: false },
    payslip: { ready: false, treat_as_error: false, show_spinner: false },
    security_questions: { ready: false, treat_as_error: false, show_spinner: false },
    security_questions_for_reset: { ready: false, treat_as_error: false, show_spinner: false, items: [] },
    verify_answers: { ready: false, treat_as_error: false, show_spinner: false },
    reset_pin: { ready: false, treat_as_error: false, show_spinner: false },
    login: { ready: false, treat_as_error: false, authorized: false, show_spinner: false },
    register: { ready: false, treat_as_error: false, authorized: false, show_spinner: false },
    verify_nino: { ready: false, treat_as_error: false, authorized: false, show_spinner: false },
    token: null,
    oauth_token: null,
    google_oauth_token: null,
    desktopLayout: false,
    print_payslip: null
}

function reducer(state = initial_state, action) {
    switch(action.type) {
        case "AUTHENTICATED_WITH_PIN": {
            return {...state, authenticated_with_pin: true}
        }
        case "SAVE":
            const data = {...action.data}
            return {...state, ...data }
        case "DATA_LOADING":
            return {...state, ...action.data}
        case "DATA_LOADED":
            return {...state, ...action.data}
        case "DATA_PUSH_ITEMS":
            const key = Object.keys(action.data)[0]
            return {...state, [key]: {...state.all_payslips, ...action.data[key], items: [...state.all_payslips.items, ...action.data.all_payslips.items] }}
        case "SET_TOKEN":
            return {...state, token: action.data}
        case "CLEAR_STORE":
            return {...initial_state, current_user: {...state.current_user}, oauth_token: state.oauth_token }
        case "PIN_SETUP":
            return {...state, current_user: {...state.current_user, is_pin_setup: true}}
        case "RESET_VERIFY_ANSWERS":
            return {...state, verify_answers: initial_state.verify_answers}
        default:
            return state

    }
}

function globalReducer( state, action ) {
    switch( action.type ) {
        case "HYDRATE_STORE":
            return {...state, ...action.data }
        default:
            return combineReducers({store: reducer, routing: routerReducer, browser: responsiveStateReducer})(state, action)
    }
}



let store = createStore( globalReducer,
                         composeEnhancers( responsiveStoreEnhancer, applyMiddleware( reduxThunk, routerMiddleware(browserHistory)) ) )

function loadData(type, url, postPayload, callback) {

    store.dispatch( {
        type: "DATA_LOADING",
        data: {
            [type]:{ ready: false, error: false, show_spinner: true }
        }
    } )

    const options = {
        headers: {
            'Accept': 'application/json',
            'morri-auth': store.getState().store.token || "",
            'epayslips-token': store.getState().store.oauth_token || "",
        }
    }


    if( postPayload ) {
        options.method = 'POST'
        options.body = JSON.stringify(postPayload)
        options.headers = { ...options.headers, "Content-Type": "application/json" }
    }

    return store.dispatch( (dispatch) => {

        return fetch(url,options).then((resp) => {
            const http_status = resp.status

            const white_list = {
                200: () => resp.json().then( (data) =>  ({...data, http_status })),
                201: () => resp.json().then( (data) =>  ({...data, http_status })),
                204: () => ({http_status}),
                404: () => ({http_status}),
                412: () => ({http_status})
            }

            if ( white_list[http_status] ) return white_list[http_status]()
            return {treat_as_error: true, http_status  }

        }).then((data) => {

            if(callback) callback(data)

            dispatch( {
                type: "DATA_LOADED", 
                data: {
                    [type]:{ ready: true, treat_as_error: false, show_spinner: false, ...data }
                }
            } )
        }).catch((error) => {
            dispatch( {
                type: "DATA_LOADED", 
                data: {
                    [type]:{ ready: true, treat_as_error: true, show_spinner: false, http_status: 501 }
                }
            } )

            if(callback) callback({[type]:{ ready: true, treat_as_error: true, show_spinner: false, http_status: 501 }})
        })
    })
}


export function clearStore() {
    browserHistory.push( "/timeout")
    stopTokenRefresh()
    store.dispatch( {type: "CLEAR_STORE"})
}

export function hydrateStore(data) {
    store.dispatch( {type: "HYDRATE_STORE", data})
}

export default store

export function mediaQuery() {
    store.dispatch(calculateResponsiveState(window))
}

export function loadLatestPayslip() {
    if( !store.getState().store.latest_payslip.ready) {
        loadData("latest_payslip", "/api/epayslips/payslips/latest")
    }
}

export function loadAllPayslips() {
    loadData("all_payslips", "/api/epayslips/payslips")
}

export function loadPayslip( id ) {
    loadData("payslip", `/api/epayslips/payslips/${id}`)
}

export function loadCurrentUser() {
    loadData("current_user", "/api/users/me")
}

export function authenticateWithPin(pin, callback) {
    loadData( "login", "/api/users/login", {"pin_number": pin}, (data) => {
        if( data.token) refreshTokenTimer()
        store.dispatch( {
            type: "SET_TOKEN",
            data: data.token
        } )
        if( data.token) loadLatestPayslip()
        if (callback) callback(data)
    })
}

export function registerUser(pin, securityQuestions ) {
    let body = {
        pin_number: pin,
        identity_verifications: Object.keys(securityQuestions).map ( (id) => {
            return {question_id: id, answer: securityQuestions[id]}
        })
    }
    loadData( "register", "/api/users/register", body, (data) => {
        if( !data.token ) return
        refreshTokenTimer()
        store.dispatch( {
            type: "SET_TOKEN",
            data: data.token
        } )

        store.dispatch( {
            type: "PIN_SETUP"
        } )

        if( data.token) loadLatestPayslip()
    })
}

export function refreshToken() {
    loadData( "refresh_token", "/api/users/refresh-token", null, (data) => {

        if( !data.token ) {
            clearStore()
            return
        }

        refreshTokenTimer()
        store.dispatch({
            type: "SET_TOKEN",
            data: data.token
        })

    })
}


export function loadSecurityQuestions() {
    if( !store.getState().store.security_questions.ready) {
        loadData("security_questions", "/api/security-questions")
    }
}


export function loadSecurityQuestionsForReset() {
    loadData( "security_questions_for_reset", "/api/users/security-questions")
}

export function verifyAnswers(securityQuestions) {
    loadData( "verify_answers", "/api/users/verify-answers", 
        {
            identity_verifications: Object.keys(securityQuestions).map ( (id) => {
                return {question_id: id, answer: securityQuestions[id]}
            })
        }, (data) => {
            if ( data.http_status === 412 ) {
                ReactGA.event({ category: 'Reset Pin', action: 'Answer Security Questions', label: "Incorrect answers"});
            }
        }
    )
}

export function resetPin(pin, securityQuestions, callback ) {
    let body = {
        pin_number: pin,
        identity_verifications: Object.keys(securityQuestions).map ( (id) => {
            return {question_id: id, answer: securityQuestions[id]}
        })
    }
    loadData( "reset_pin", "/api/users/reset-pin", body, (data) => {
        if( !data.token ) return
        store.dispatch( {
            type: "SET_TOKEN",
            data: data.token
        } )
        store.dispatch( {
            type: "RESET_VERIFY_ANSWERS"
        } )
        if( data.token) loadLatestPayslip()
        callback()
    })
}

export function save( data ) {
    store.dispatch( {type: "SAVE", data: data})
}

store.subscribe( () => {
})

mediaQuery()





// WEBPACK FOOTER //
// ./src/store.js